/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { isArray } from 'lodash';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../../components/Modal';

const ModalLayout = ({
  children = null,
  onHide = null,
  currentScreen,
  isVisible = null,
  modalHeight = null,
  withButtons = true,
  modalDialogClassName = '',
  rootClassName = '',
  modalContentStyle = {},
}) => {
  if (!isVisible) return <></>;
  return (
    <ModalRoot rootClassName={rootClassName}>
      <Modal
        withButtons={withButtons}
        contentClassName={modalHeight}
        dialogClassName={modalDialogClassName}
        contentStyle={modalContentStyle}>
        <ModalHeader>
          <i
            onClick={onHide}
            onKeyDown={onHide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>
          {isArray(children)
            ? children.filter((child) => child.props.keyName === currentScreen)
            : [children].filter((child) => child.props.keyName === currentScreen)}
        </ModalBody>
      </Modal>
    </ModalRoot>
  );
};

export default ModalLayout;

ModalLayout.propTypes = {
  currentScreen: PropTypes.string.isRequired,
  children: PropTypes.any,
  onHide: PropTypes.func,
  isVisible: PropTypes.bool,
  withButtons: PropTypes.bool,
  modalHeight: PropTypes.string,
  modalDialogClassName: PropTypes.string,
  rootClassName: PropTypes.string,
  modalContentStyle: PropTypes.object,
};
